import React from "react";
import { Label } from "@components/ui/label";
import { FieldWrapperProps } from "@autoform/react";
import { FormMessages } from "@components/form-messages";

const DISABLED_LABELS = ["boolean", "object", "array"];

export const FieldWrapper: React.FC<FieldWrapperProps> = ({
  label,
  children,
  id,
  field,
  error,
}) => {
  const isDisabled = DISABLED_LABELS.includes(field.type);

  return (
    <div className="space-y-2">
      {!isDisabled && (
        <Label htmlFor={id}>
          {label}
          {field.required && <span className="text-destructive"> *</span>}
        </Label>
      )}
      {children}
      {field.fieldConfig?.description && (
        <p className="text-sm text-muted-foreground border-red-300">
          {field.fieldConfig.description}
        </p>
      )}
      {error && (
        <FormMessages
          type="error"
          className="pt-1 text-sm"
          messages={[error]}
        />
      )}
    </div>
  );
};
